import useSWR from "swr";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import { AdAssetGroup } from "../types/ad-asset-group";

const useAdAssetGroup = (adAssetGroupId: number, brandId: number) => {
  const params = new URLSearchParams();

  params.append("brand_id", brandId.toString());
  const { data, error, isLoading, mutate } = useSWR<AdAssetGroup>(
    `${RelativeUrl}/ad_asset_groups/${adAssetGroupId}?${params.toString()}`,
    fetcher
  );

  return {
    adAssetGroup: data,
    isLoading,
    error,
    invalidateAdAssetGroupCache: mutate
  };
};

export default useAdAssetGroup;
